import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from '@sentry/angular';
import { BrowserTracing } from '@sentry/tracing';

Sentry.init({
  dsn: environment.sentry.dsn,
  environment: environment.sentry.environment,
  integrations: [
    new BrowserTracing({
      tracePropagationTargets: environment.sentry.targets,
      routingInstrumentation: Sentry.routingInstrumentation
    }),
  ],
  tracesSampleRate: environment.sentry.rate
});

// Set sentry configuration to localStorage for other sub-pages consumption
localStorage.setItem("sentry:dsn", environment.sentry.dsn);
localStorage.setItem("sentry:environment", environment.sentry.environment);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
